import { H3 } from '@berlitz/globals'
import first from 'lodash/first'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row } from 'react-styled-flexboxgrid'
import Avatar from '@components/Avatar'
import Radio from '@components/Radio'
import { Comment } from '@interfaces/MyLesson'
import WithUserTime, { WithUserTimeProps } from '@hocs/WithUserTime'
import { NoteProp } from './interface'
import { Profile, AvatarContainer, StyledCol, PName, PDate, Message, RadioContainer, StyledH3Col } from './style'
import useTimeFormat from '@hooks/useTimeFormat'
import { DATE_FORMAT } from '@utils/constants'

const Notes: React.FC<NoteProp & WithUserTimeProps> = ({ comments = [], groupComments, toUserDate }) => {
  const { convertToUserTimeFormats } = useTimeFormat()
  const [time, setTime] = React.useState('')
  const [stateComments, setStateComments] = React.useState([] as Comment[])

  React.useEffect(() => {
    if (groupComments.length) {
      const groupComment = first(groupComments)
      setTime(groupComment!.StartTime)
      setStateComments(groupComment!.Notes)
    } else {
      setStateComments(comments)
    }
  }, [])

  return (
    <>
      <Row>
        <StyledH3Col xs={12} md={12}>
          <H3 className="margin-bottom-20">
            <FormattedMessage id="Notes and comments" />
          </H3>
        </StyledH3Col>
      </Row>

      {groupComments.length > 0 && (
        <RadioContainer>
          <Radio.Group
            value={time}
            onChange={(e: any) => {
              const time = e.target.value
              const groupComment = groupComments.find(gc => gc.StartTime === time)
              setTime(time)
              setStateComments(groupComment!.Notes)
            }}
            name="notes"
          >
            {groupComments.map(gc => (
              <Radio.Button key={gc.StartTime} id={`notes-${gc.StartTime}`} value={gc.StartTime}>
                {convertToUserTimeFormats(
                  [
                    toUserDate(gc.StartTime, 'YYYY-MM-DD HH:mm:ss', DATE_FORMAT.HM),
                    toUserDate(gc.EndTime, 'YYYY-MM-DD HH:mm:ss', DATE_FORMAT.HM),
                  ],
                  [DATE_FORMAT.HM, DATE_FORMAT.HM]
                )?.join(' - ')}
              </Radio.Button>
            ))}
          </Radio.Group>
        </RadioContainer>
      )}

      <Row>
        {stateComments.map(item => (
          <StyledCol key={item.Id} xs={12} md={12}>
            <Profile>
              <AvatarContainer backgroundColor={item.BackgroundColor} foregroundColor={item.ForegroundColor}>
                <Avatar type="profile" size="38px" />
              </AvatarContainer>
              <div>
                <PName>
                  {item.Name} ({item.Role})
                </PName>
                {item.Date && <PDate>{item.Date}</PDate>}
              </div>
            </Profile>
            <Message>{item.Message}</Message>
          </StyledCol>
        ))}
      </Row>
    </>
  )
}

export default WithUserTime(Notes)
